import * as React from 'react'

import { QRCode } from '~/client/src/shared/components/LazyQRCode'
import ThemeMode from '~/client/src/shared/utils/ThemeModeManager'

import Colors from '~/client/src/shared/theme.module.scss'

const QR_CODE_TO_PRINT_SIZE = 700
const QR_CODE_LOGO_SRC = '/static/icons/strux-hub-dark-with-background.svg'

interface IQRCodeRendererProps {
  url: string
  caption: string
  icon: JSX.Element
}

const QRCodeRenderer: React.FC<IQRCodeRendererProps> = ({
  url,
  caption,
  icon,
}) => {
  return (
    <div className="col x-center">
      <QRCode
        value={url}
        logoImage={QR_CODE_LOGO_SRC}
        size={QR_CODE_TO_PRINT_SIZE}
        fgColor={ThemeMode.getHEXColor(Colors.neutral0)}
      />
      <div className="row x-center text bold size24">
        {icon}
        {caption}
      </div>
    </div>
  )
}

export default QRCodeRenderer
